import React, { useContext } from 'react';
import ClassNames from 'classnames';
import CalendarPickerContext from '../context/CalendarPickerContext';
import { DEFAULT_RANGE_MENU } from '../utils/constants';
import { getKeyTable } from '../utils/NavUtils';
var LeftMenu = function LeftMenu(props) {
  var _props$autoClose = props.autoClose,
    autoClose = _props$autoClose === void 0 ? true : _props$autoClose,
    _props$rangeMenuItems = props.rangeMenuItems,
    rangeMenuItems = _props$rangeMenuItems === void 0 ? DEFAULT_RANGE_MENU : _props$rangeMenuItems,
    minDate = props.minDate,
    maxDate = props.maxDate,
    disabledDays = props.disabledDays,
    disabledDates = props.disabledDates,
    disabledRanges = props.disabledRanges,
    maxDetail = props.maxDetail,
    selectRange = props.selectRange;
  var _useContext = useContext(CalendarPickerContext),
    dateValidator = _useContext.dateValidator,
    momentUtils = _useContext.momentUtils,
    valueDispatch = _useContext.valueDispatch,
    value = _useContext.value,
    activeStartDateDispatch = _useContext.activeStartDateDispatch,
    inputValueDispatch = _useContext.inputValueDispatch,
    leftPanelRefList = _useContext.leftPanelRefList,
    viewDispatch = _useContext.viewDispatch,
    keyboardControlStore = _useContext.keyboardControlStore,
    openStatusDispatch = _useContext.openStatusDispatch,
    openStatusStore = _useContext.openStatusStore,
    keyboardControlAreaDispatch = _useContext.keyboardControlAreaDispatch;
  var isSame = momentUtils.isSame,
    addDate = momentUtils.addDate,
    isSameOrBefore = momentUtils.isSameOrBefore;
  var checkMenuItemDisabled = function checkMenuItemDisabled(index, props) {
    var startDate = rangeMenuItems[index].dates[0];
    var endDate = rangeMenuItems[index].dates[1];
    var isAllDisabled = true;
    while (isSameOrBefore(startDate, endDate)) {
      if (dateValidator.isValidDateValueByRules({
        date: startDate,
        minDate: minDate,
        maxDate: maxDate,
        disabledDays: disabledDays,
        disabledDates: disabledDates,
        disabledRanges: disabledRanges
      })) {
        isAllDisabled = false;
      }
      startDate = addDate(startDate, 1, 'day');
    }
    return isAllDisabled;
  };
  var handleRangeChange = function handleRangeChange(index, disabled, isKeyboard) {
    if (isKeyboard === void 0) {
      isKeyboard = false;
    }
    if (!rangeMenuItems[index]) return;
    if (disabled) return;
    var targetValue = rangeMenuItems[index].dates;
    if (targetValue instanceof Array) {
      activeStartDateDispatch({
        type: 'setActiveStartDate',
        payload: {
          activeStartDateLeft: rangeMenuItems[index].dates[0]
        }
      });
    } else if (targetValue instanceof Date) {
      activeStartDateDispatch({
        type: 'setActiveStartDate',
        payload: {
          activeStartDateLeft: rangeMenuItems[index].dates
        }
      });
    } else {
      console.warn("Type Error: incorrect type of rangeMenuItems dates value, should be Array<Date> or Date");
    }
    if (targetValue instanceof Date) {
      targetValue = [targetValue, targetValue];
    }
    targetValue = refineRangeMenuDates(targetValue);
    if (autoClose) {
      if (openStatusStore.isOpen) {
        openStatusDispatch({
          type: "close",
          payload: {
            isKeyboard: isKeyboard
          }
        });
        keyboardControlAreaDispatch({
          type: "setInputFocus",
          payload: {
            isKeyboard: isKeyboard
          }
        });
        keyboardControlAreaDispatch({
          type: "clearNav"
        });
      }
    }
    valueDispatch({
      type: "setValue",
      payload: {
        value: targetValue
      }
    });
    inputValueDispatch({
      type: 'setInputValueByDate',
      payload: {
        value: targetValue
      }
    });
    viewDispatch({
      type: 'goTargetView',
      payload: {
        targetView: maxDetail || 'month'
      }
    });
  };
  var getMenuChecked = function getMenuChecked() {
    if (!value) return;
    var newMenuChecked = "";
    for (var index = 0; index < rangeMenuItems.length; index++) {
      var _index = String(index);
      var tempRange = rangeMenuItems[index].dates;
      if (tempRange instanceof Array) {
        if (value instanceof Array) {
          if (isSame(tempRange[0], value[0]) && isSame(tempRange[1], value[1])) {
            newMenuChecked = _index;
          }
        } else if (value instanceof Date && !selectRange) {
          if (isSame(tempRange[0], value) && isSame(tempRange[1], value)) {
            newMenuChecked = _index;
          }
        } else {
          continue;
        }
      } else if (tempRange instanceof Date) {
        if (value instanceof Array) {
          if (isSame(tempRange, value[0]) && isSame(tempRange, value[1])) {
            newMenuChecked = _index;
          }
        } else if (value instanceof Date && !selectRange) {
          if (isSame(tempRange, value)) {
            newMenuChecked = _index;
          }
        } else {
          continue;
        }
      } else if (tempRange instanceof Date && value instanceof Array) {
        if (isSame(tempRange, value[0]) && isSame(tempRange, value[1])) {
          newMenuChecked = _index;
        }
      } else {
        continue;
      }
    }
    return newMenuChecked;
  };
  var refineRangeMenuDates = function refineRangeMenuDates(originDateRange) {
    var diff = momentUtils.diff,
      addDate = momentUtils.addDate,
      subtractDate = momentUtils.subtractDate,
      getStartDate = momentUtils.getStartDate,
      getEndDate = momentUtils.getEndDate;
    var isValidDateValueByRules = dateValidator.isValidDateValueByRules;
    if (originDateRange instanceof Date) {
      return [getStartDate(originDateRange, 'day'), getEndDate(originDateRange, 'day')];
    }
    var startDate = originDateRange[0];
    var endDate = originDateRange[1];
    var left = 0,
      right = diff(startDate, endDate, 'day');
    var p1 = startDate;
    var p2 = endDate;
    var startToEnd = true;
    var endToStart = true;
    for (var i = left; i <= right; i++) {
      if (startToEnd) p1 = addDate(startDate, i, 'day');
      if (endToStart) p2 = subtractDate(endDate, i, 'day');
      if (isValidDateValueByRules({
        date: p1,
        minDate: minDate,
        maxDate: maxDate,
        disabledDays: disabledDays,
        disabledDates: disabledDates,
        disabledRanges: disabledRanges
      })) {
        startDate = p1;
        startToEnd = false;
      }
      if (isValidDateValueByRules({
        date: p2,
        minDate: minDate,
        maxDate: maxDate,
        disabledDays: disabledDays,
        disabledDates: disabledDates,
        disabledRanges: disabledRanges
      })) {
        endDate = p2;
        endToStart = false;
      }
      if (!startToEnd && !endToStart) break;
    }
    return [getStartDate(p1, 'day'), getEndDate(p2, 'day')];
  };
  var handleLeftMenuKeyDown = function handleLeftMenuKeyDown(e, index, disabled) {
    e.preventDefault();
    var _getKeyTable = getKeyTable(e),
      isEnter = _getKeyTable.isEnter,
      isSpace = _getKeyTable.isSpace;
    if (isEnter || isSpace) {
      handleRangeChange(index, disabled, true);
    }
  };
  var childs = rangeMenuItems.map(function (e, index) {
    var _name = e.name;
    var _index = String(index);
    var disabled = checkMenuItemDisabled(index, props);
    var cn = ClassNames("a-clendar-left-menu-content-item", {
      checked: getMenuChecked() === _index,
      "disabled": disabled
    });
    return /*#__PURE__*/React.createElement("div", {
      role: "button",
      key: _index,
      className: cn,
      tabIndex: 0,
      onKeyDown: function onKeyDown(e) {
        return handleLeftMenuKeyDown(e, _index, disabled);
      },
      onClick: function onClick() {
        return handleRangeChange(_index, disabled);
      },
      ref: function ref(_ref) {
        return leftPanelRefList.set(_index, _ref);
      }
    }, _name);
  });
  //handle nav behaviour
  if (leftPanelRefList && leftPanelRefList.get(keyboardControlStore.keyboardControlArea)) {
    setTimeout(function () {
      leftPanelRefList.get(keyboardControlStore.keyboardControlArea).focus();
    }, 0);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "a-clendar-left-menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "a-calenar-menu-header"
  }, "Date range"), /*#__PURE__*/React.createElement("div", {
    className: "a-clendar-left-menu-content"
  }, childs));
};
export default LeftMenu;